// Wording is intentionally "Copying…" (not "Copied") — copy runs async as a background job.
export function getCopyBillsToastMessage(queuedCount: number, selectedCount: number): string {
    const billNoun = queuedCount === 1 ? "bill" : "bills";
    return `Copying ${queuedCount} of ${selectedCount} ${billNoun}. This may take a few minutes to complete.`;
}
